// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lythaammlxbahrszjgxw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx5dGhhYW1tbHhiYWhyc3pqZ3h3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIwMjIyMDAsImV4cCI6MjA2NzU5ODIwMH0.uTaoBs0-utMcOJWkFbrElf2DgNAPwf4XtDOTsYzT_-w";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});